import React, { useEffect, useState } from 'react'
import { Badge, Card, Image } from 'react-bootstrap'
import Skeleton from '@material-ui/lab/Skeleton';
import Aos from 'aos'
import 'aos/dist/aos.css'

export const AboutScreen = () => {

    const [loaded, setLoaded] = useState(false)
    useEffect(()=>{
        Aos.init({})
    },[])
    
    return (
        <div style={{ textAlign:'left', marginTop:"4rem", overflowX:"hidden !important", color:"rgba(255,255,255,.70)" }} className='p-4' id='about' >
            <div style={{ textAlign: 'center', width:'100%'}}>
                {typeof window==='object' && window.innerWidth>1000 ? 
                <div className="d-flex" style={{ alignItems:'center' }}>
                    <div data-aos="fade-right" className='ml-5 pl-5' data-aos-duration="1000" style={{ alignItems:"center" }}>
                        <>
                        {!loaded 
                        ?
                        <>
                        <Skeleton className='mb-5 mx-auto' animation="wave" width={400} height={500} style={{ color:"rgba(255,255,255,.70)", backgroundColor:"rgba(255,255,255,.70)", borderRadius:"2rem" }} variant="rect" /> 
                        <img src="https://firebasestorage.googleapis.com/v0/b/portfolio-d37b7.appspot.com/o/IMG_20221119_212902.jpg?alt=media&token=a16e010b-bf48-49f1-b584-d23596750bb9" alt="Aditya Uday Ubale" onLoad={() => setLoaded(true)} style={{ display:"none" }} />
                        </>
                        :<Image src="https://firebasestorage.googleapis.com/v0/b/portfolio-d37b7.appspot.com/o/IMG_20221119_212902.jpg?alt=media&token=a16e010b-bf48-49f1-b584-d23596750bb9" style={{ width:'50vh', flex:0.3, borderRadius:"2rem" }} className='my-2'/>
                        }
                        </>
                        <Card.Title><Badge variant='dark' className='px-2 py-2 mx-auto' >Turning creativity into {'<code/>'}</Badge></Card.Title>
                    </div>
                    <div data-aos="fade-right" data-aos-duration="1000" style={{ flex:0.84, textAlign:'left' }} className='ml-auto'>
                        <div className='h2'>const aboutMeBrief = {"{"}</div>
                        <div className='h5 pl-5'>"name" : "Aditya Uday Ubale",</div>
                        <div className='h5 pl-5'>"since" : "25th Feb 2001",</div>
                        <div className='h5 pl-5'>"aim" : "Fullstack Developer",</div>
                        <div className='h5 pl-5'>"stack" : ["MongoDB", "ExpressJS", "ReactJS", "NodeJS"],</div>
                        <div className='h5 pl-5'>"favourite_editor" : "VS Code",</div>
                        <div className='h5 pl-5'>"tech_languages" : ["JavaScript*", "Python", "C++", "Java"],</div>
                        <div className='h5 pl-5'>"hobbies" : ["Drawing", "Movies", "Long Rides"]</div>
                        <div className='h5 pl-5'>"weakness" : ["Communication", "Introvert", "Unable to socialize"]</div>
                        <div className='h5 pl-5'>"languages_i_speak" : ["English", "Hindi", "Marathi"]</div>
                        <div className='h5 pl-5'>"services_provided" : ["Frontend", "Backend", "SEO"]</div>
                        <div className='h5 pl-5'>"contact" : "Search below for cotacting me."</div>
                        <div className='h2' >{"}"}</div>
                    </div>
                </div>
                :
                <>
                    <h3 data-aos="fade-down" className='mx-auto mobile_anime' style={{ width:"max-content" }}>About Me...</h3>
                    <>
                        {!loaded 
                        ?
                        <>
                            <Skeleton className='mb-5 mx-auto' animation="wave" width={300} height={500} style={{ color:"rgba(255,255,255,.70)", backgroundColor:"rgba(255,255,255,.70)", borderRadius:"2rem" }} variant="rect" /> 
                            <img src="https://firebasestorage.googleapis.com/v0/b/portfolio-d37b7.appspot.com/o/IMG_20221119_212902.jpg?alt=media&token=a16e010b-bf48-49f1-b584-d23596750bb9" alt="Aditya Uday Ubale" onLoad={() => setLoaded(true)} style={{ display:"none" }} />
                        </>
                        :<Image data-aos="zoom-in" data-aos-duration="1000" src="https://firebasestorage.googleapis.com/v0/b/portfolio-d37b7.appspot.com/o/IMG_20221119_212902.jpg?alt=media&token=a16e010b-bf48-49f1-b584-d23596750bb9" style={{ width:'48vh', borderRadius:"2rem" }} fluid className='my-2'/>
                        }
                    </>
                    <Card.Title data-aos="zoom-in" data-aos-duration="1000"><Badge variant='dark' className='px-2 py-2' >Turning creativity into {'<code/>'}</Badge></Card.Title>
                </>
                }
                <hr></hr>
            </div>
            <div data-aos="fade-right" data-aos-duration="1000" style={{ fontSize:'2.3vh', lineHeight:1.5 }} className='p-1'>
                <h3>
                    Let me <Badge variant='info'>introduce</Badge> myself!
                </h3>
                Hi there, yes that's me, <b>Aditya</b>, kind of obvious seeing the name of the webpage ^_^' .  
                I am a student from <b>Jabalpur</b> currently pursuing Bachelor of Engineering in Computer Science Major
                from Indore . I did my basic and primary schooling from a local domestic school 
                and then took the SSC and HSC from the CBSE (Central Board of Secondary Education) Board .
                Going further I took the JEE entrance examination and got admision to <b>IET DAVV</b> to pursue my Engineering course , 
                in which the field of web development attracts me the most . And yes my favourite code editor is <Badge variant='danger' style={{ fontSize:'2.3vh' }} >VSCode</Badge>
                <hr></hr>
            </div>
            <div data-aos="fade-right" data-aos-duration="1000" style={{ fontSize:'2.3vh', lineHeight:2 }} className='px-1 pb-3' >
                <h3>
                    <Badge variant='primary'>Hobbies</Badge> and Other things...
                </h3>
                I am a frontend developer (for now) and I love developing the user interfaces and the improve the user experience . 
                My hobbies include : 
                <li><b>Most Favourite : </b>Long bike trips ( alone or in a group ) </li>
                <li><b>Outdoor Sports : </b>Cricket</li>
                <li><b>Indoor Sports : </b>Carrom ( College champion ) and Badminton</li>
                <li><b>Art : </b>Sketching and Crafting things from waste</li> 
                <li><b>Leisure time : </b>Watching movies ( Genre : Action and crime )</li>
                Besides I also have a corner for playing instruments ( tabla and harmonium )
                <hr></hr>
            </div>
            <div style={{ fontSize:'2.3vh', lineHeight:2 }} data-aos="fade-right" data-aos-duration="1000"className='px-1 pb-3' >
                <h3>
                    <Badge variant='success' >Strengths</Badge> and <Badge variant='danger'>Weaknesses</Badge>
                </h3>
                    It is good to share strengths with everyone rather than weaknesses , but
                    sharing weaknesses gives the actual image of ourselves to the world rather than 
                    showing the false image . 
                    <br/>So weakness first : 
                    <li>Communication in <b>English</b>, I am unable to express myself by saying things but I can do so by writing them in <b>English</b></li>
                    <li>Being able to socialize, I am unable to make connections with people very easily</li>
                    These are the ones that always keep me back and reaching my full potential
                    <br/>As far as strengths go : 
                    <li><b>Technically : </b>problem solving, data structures and algorithms, design and development</li>
                    <li>Most valuable : learning new skills</li>
                <hr></hr>
            </div>
            <div style={{ fontSize:'2.3vh', lineHeight:2 }} data-aos="fade-right" data-aos-duration="1000" className='px-3 pb-3' >
                <h3>
                    <Badge variant='info' >Languages</Badge> I speak
                </h3>
                <li>Mother tongue : Marathi ( native )</li>
                <li>Daily : Hindi ( full proficient )</li>
                <li>English ( can communicate verbally but prefer written communication )</li>
                <hr></hr>
            </div>
            <div style={{ fontSize:'2.3vh', lineHeight:2 }} data-aos="fade-right" data-aos-duration="1000" className='px-1 pb-3' >
                <h3>
                    Future <Badge variant='secondary'>goals</Badge> and further approach...
                </h3>
                I am looking forward to be a fully established full stack web developer ( both backend and frontend ) in 
                MERN (MongoDB, ExpressJS, ReactJS, NodeJS) stack . I took steps and got a good control over ReactJS and now I am currently working on the backend stuff . 
                Also due to university curriculum I am working in Android Development , therefore there are chances that I might end up being an Android Developer , 
                though the chances are low but not null . 
                <hr></hr>
            </div>
            <div style={{ fontSize:'2.3vh', lineHeight:2 }} data-aos="fade-right" data-aos-duration="1000" className='px-1 pb-3' >
                <h3>
                    <Badge variant='warning'>Concluding</Badge> 
                </h3>
                The old school concluding goes : I am a determined and hard working person that does the work assigned in time.....
                <br/>
                Yes that's true but let's end it in a different way, 
                I am a frontend developer spending time writing code ( lots of it ), 
                also I don't drink coffee (^_^') . I am actively looking to gain some industry exposure via internships or part time jobs . 
                Go through the Hire me section if you are interested in hiring someone who could give 100% every single time .  
                <hr></hr>
            </div>
        </div>
    )
}
